// extracted by mini-css-extract-plugin
module.exports = {"dialog":"crm-c_dialog__8y8Js","container":"crm-c_container__SSjv0","actionButton":"crm-c_actionButton__wR_0N","form":"crm-c_form__35L3B","remark":"crm-c_remark__pEoQB"};